export default __webpack_public_path__ + "static/media/FlatUparrow.5831f33c.svg";